import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e67697b8")

_pushScopeId("data-v-e67697b8")
const _hoisted_1 = { class: "flex-center paragraph" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "flex-1",
      innerHTML: _ctx.content
    }, null, 8, ["innerHTML"]),
    _createVNode(_component_el_tooltip, {
      content: "引用",
      "show-after": 500,
      placement: "bottom",
      effect: "light"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_button, {
          class: "ref-button",
          size: "small",
          icon: "el-icon-d-arrow-right",
          circle: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reference')))
        })
      ]),
      _: 1
    })
  ]))
})